import axios from "axios";
import { API } from "@/lib/api";

const authCfg = () => {
    const cfg = { withCredentials: true };
    try {
        const t = new URLSearchParams(window.location.search).get("admin_token");
        if (t) cfg.headers = { Authorization: `Bearer ${t}` };
    } catch (e) {}
    return cfg;
};

export const adminOverview = () => axios.get(`${API}/admin/overview`, authCfg()).then(r => r.data);
export const adminLogin = (password) => axios.post(`${API}/admin/login`, { password }, { withCredentials: true }).then(r => r.data);
export const adminCheck = () => axios.get(`${API}/admin/check`, authCfg()).then(r => r.data);
export const adminUsers = (q = "") => axios.get(`${API}/admin/users`, { ...authCfg(), params: { q } }).then(r => r.data);
export const adminExportUrl = `${API}/admin/export-emails`;
export const adminGetSettings = () => axios.get(`${API}/admin/settings`, authCfg()).then(r => r.data);
export const adminPutSettings = (body) => axios.put(`${API}/admin/settings`, body, authCfg()).then(r => r.data);
export const adminListDiscounts = () => axios.get(`${API}/admin/discounts`, authCfg()).then(r => r.data);
export const adminCreateDiscount = (body) => axios.post(`${API}/admin/discounts`, body, authCfg()).then(r => r.data);
